import { ProductPriceVariant, ProductStockLocation, ProductVariant as APIProductVariant } from "@crystallize/schema/catalogue";
import { getCurrencyFromCode } from "../../contracts/Currency";
import { Price } from "../../contracts/Price";
import { ProductVariant } from "../../contracts/ProductVariant";
import { StockLocation } from "../../contracts/StockLocation";
import { DataMapper } from "..";

interface APIProductVariantExtended extends APIProductVariant {
  // Dropped from the schema 6 type, but still selected by our queries.
  id?: string;
  outofstock: {
    content: {
      value: boolean;
    };
  };
}

function mapPriceVariants(
  rawVariants: ProductPriceVariant[],
): Record<string, Price> {
  return rawVariants.reduce((memo: any, priceVariant: ProductPriceVariant) => {
    return {
      ...memo,
      [priceVariant.identifier!]: {
        identifier: priceVariant.identifier,
        value: priceVariant.price || 0.0,
        currency: getCurrencyFromCode(priceVariant.currency || "NOK"),
        name: priceVariant.name || "Unknown",
        priceFor: {
          identifier: priceVariant.priceFor?.identifier || "",
          price: priceVariant.priceFor?.price,
        },
      },
    };
  }, {});
}

export default function APIProductVariantToProductVariant(
  variant: APIProductVariantExtended,
): ProductVariant {
  const mapper = DataMapper();

  const priceVariants = mapPriceVariants(variant?.priceVariants ?? []);
  const images =
    variant?.images ?? (variant?.firstImage ? [variant?.firstImage] : []);
  return {
    id: variant?.id!,
    isDefault: !!variant?.isDefault,
    name: variant?.name || "Unknown",
    sku: variant?.sku!,
    priceVariants,
    stockLocations:
      variant?.stockLocations?.reduce(
        (
          memo: Record<string, StockLocation>,
          stockLocation: ProductStockLocation,
        ) => {
          return {
            ...memo,
            [stockLocation.identifier!]: {
              identifier: stockLocation.identifier!,
              name: stockLocation.name || "Unknown",
              stock: stockLocation.stock || 0,
            },
          };
        },
        {},
      ) || {},
    images: mapper.API.Object.APIImageToImage(images),
    attributes:
      variant?.attributes?.reduce((memo: Record<string, string>, attribute) => {
        return {
          ...memo,
          [attribute.attribute!]: attribute.value || "",
        };
      }, {}) || {},
    outofstock: {
      content: { value: variant?.outofstock?.content?.value || false },
    },
  };
}
